import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/salary-income-calculator',
  component: () => import('../../routes/SalaryIncomeCalculator.svelte'),
  card: {
    id: 'salary-income-calculator',
    title: 'Salary & Income Calculator',
    description: 'Convert hourly, daily, weekly, monthly, and annual income into all pay periods instantly.',
    icon: 'payments',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/salary-income-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Salary & Income Calculator – Convert Hourly, Daily, Weekly, Monthly & Annual Income',
    description: 'Free salary calculator that converts between hourly, daily, weekly, monthly, and annual income. See your exact equivalent pay for any frequency — perfect for comparing job offers and negotiating salary.',
  },
};

export default meta;
